import { InputLabel, Typography } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import { styled, Theme } from '@mui/material/styles';
import { ReportingStatus } from 'api';
import {
  ACTIVE_STATUSES,
  IN_PROGRESS_STATUSES,
  PAUSED_STATUSES,
} from './constants';
import { StatusTypographyStyleProps } from './types';

function getStatusColor(theme: Theme, status: ReportingStatus): string {
  if (ACTIVE_STATUSES.includes(status)) {
    return theme.palette.success.main;
  }

  if (IN_PROGRESS_STATUSES.includes(status)) {
    return '#B7950B';
  }

  if (PAUSED_STATUSES.includes(status)) {
    return theme.palette.warning.main;
  }

  return theme.palette.grey[700];
}

export const WidgetIdFormControl = styled(FormControl)`
  width: 285px;
`;

export const SelectInputLabel = styled(InputLabel)`
  background-color: ${({ theme }) => theme.palette.common.white};
  font-size: ${({ theme }) => theme.typography.label.fontSize};
`;

export const StatusTypography = styled(Typography)<StatusTypographyStyleProps>`
  color: ${({ theme, $status }) => getStatusColor(theme, $status)};
  font-weight: 600;
`;
